export const filterEmpty = (inkMatches = {}) => {
  return Object.keys(inkMatches).reduce((acc, key) => {
    if (inkMatches[key].value) {
      acc[key] = inkMatches[key];
    }
    return acc;
  }, {});
};
